export const MAX_FILE_SIZE_MB = 100;

export const ALLOWED_EXTENSIONS = new Set([
  'jpg', 'jpeg', 'gif', 'png', 'bmp', 'tif', 'tiff', 'heic', 'heif',
  'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx',
  'odt', 'ods', 'odp', 'pdf',
  'numbers', 'pages', 'key',
  'zip', 'rar', 'gz', 'tar', '7z',
  'csv', 'txt', 'json', 'xml', 'rtf', 'sig', 'geojson', 'kml', 'crp',
  'mp4', 'mov', 'avi', 'mkv', 'webm', 'wmv',
]);

export const ACCEPT = [...ALLOWED_EXTENSIONS].map((ext) => `.${ext}`).join(',');

export const fileExtension = (file) => file.name?.split('.').pop()?.toLowerCase();

export const formatFileSize = (bytes = 0) => {
  const kb = (bytes || 0) / 1024;

  return kb < 1024 ? `${Math.max(1, Math.round(kb))} KB` : `${(kb / 1024).toFixed(1)} MB`;
};
